export const SET_AUTH_TAB_NUMBER = 'SET_AUTH_TAB_NUMBER';

export const setAuthTabNumber = authTab => ({
    type: SET_AUTH_TAB_NUMBER,
    payload: authTab,
})

